import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BYPASS_TOAST } from '@smata-data-access';
import { ApiResponse, ResponseData } from '@smata-models';
import { environment } from '@smata-shared';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly urlBase = `${environment.apiUrl}/api/auth`;

  requestPasscode(identifier: string, isResend: boolean = false) {
    return this.http.post<ApiResponse<ResponseData>>(`${this.urlBase}/request-passcode`, {
      identifier,
      isResend,
    });
  }

  verifyPasscode(identifier: string | null, passcode: string) {
    return this.http.post<ApiResponse<string>>(
      `${this.urlBase}/verify-passcode`,
      {
        identifier,
        inputPasscode: passcode,
      },
      {
        context: new HttpContext().set(BYPASS_TOAST, true),
      },
    );
  }

  refreshToken() {
    return this.http.post<ApiResponse<string>>(
      `${this.urlBase}/refresh`,
      {},
      {
        context: new HttpContext().set(BYPASS_TOAST, true),
      },
    );
  }

  logout() {
    return this.http.post<ApiResponse<ResponseData>>(`${this.urlBase}/logout`, {});
  }
}
